import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SampleComponent } from './sample.component';

/**
 * A module containing objects associated with the sample component
 */

export class SampleModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  declarations: [SampleComponent],
  exports: [SampleComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
